import * as React from 'react';
import { Icon } from '../../icon/icon';

export const IconSpinner: React.FC = () => (
    <i className="app-spinner animate-[app-spinner-rotate_2s_linear_infinite]">
        <Icon viewBox="0 0 50 50" fill="none">
            <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                strokeWidth="5"
                className="stroke-current [stroke-linecap:round] animate-[app-spinner-dash_1.5s_ease-in-out_infinite]"
            />
        </Icon>
    </i>
);
